import list from 'src/modules/division/list/divisionListReducers';
import form from 'src/modules/division/form/divisionFormReducers';
import view from 'src/modules/division/view/divisionViewReducers';
import destroy from 'src/modules/division/destroy/divisionDestroyReducers';
import importerReducer from 'src/modules/division/importer/divisionImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
